import { Box, Paper } from '@mui/material';
import React from 'react';
import { headerTypographyProps } from '../../../styles/sxStyling';
import { Integration } from '../../../types/Integration';
import { organizationCalendarStatus } from '../../organizations/organizationsStyles';

type Props = {
  integration: Integration;
};

export default function GoogleEventIntegration({ integration }: Props) {
  return (
    <Paper sx={{ display: 'flex', gap: '0.5rem', width: '100%', p: '0.5rem', alignItems: 'center' }}>
      <Box sx={{ ...headerTypographyProps, fontSize: '1rem' }}>Google Calendar -</Box>
      {integration?.settings?.calendar_name && (
        <Box sx={{ ...headerTypographyProps, fontSize: '0.875rem', fontWeight: 'normal' }}>{integration.settings.calendar_name} -</Box>
      )}
      {integration?.enabled ? (
        <Box sx={{ ...organizationCalendarStatus, backgroundColor: 'var(--status-success)', fontSize: '0.875rem' }}>Synced</Box>
      ) : (
        <Box sx={{ ...organizationCalendarStatus, backgroundColor: 'red', fontSize: '0.875rem' }}>Not Synced</Box>
      )}
    </Paper>
  );
}
